function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 93.172,
    height: 93.766,
    viewBox: "0 0 24.652 24.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.49-88.9h48.705v48.705H252.49z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.67307,
      strokeDasharray: "none"
    },
    transform: "scale(1 -1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m277.917 64.867-.037-.057h.037z",
    clipPath: "url(#a)",
    style: {
      fill: "#000102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.5
    },
    transform: "matrix(.66298 0 0 -.66298 -169.241 54.66)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.67 81.688c-1.518 0-2.748-1.201-2.748-2.681V46.948c0-1.48 1.23-2.68 2.747-2.68h31.688c1.518 0 2.748 1.2 2.748 2.68v32.059c0 1.48-1.23 2.68-2.748 2.68zm5.752-6.282a4.191 4.191 0 0 0 .685-.058 3.505 3.505 0 0 0 .611-.165 3.048 3.048 0 0 0 .532-.263 2.796 2.796 0 0 0 .64-.558 2.718 2.718 0 0 0 .437-.72 2.972 2.972 0 0 0 .169-.554 3.25 3.25 0 0 0 .066-.602 3.3 3.3 0 0 0-.056-.59 2.923 2.923 0 0 0-.286-.805 2.73 2.73 0 0 0-.969-1.027 2.977 2.977 0 0 0-.543-.269 3.336 3.336 0 0 0-.624-.169 3.865 3.865 0 0 0-.699-.059h-.036a3.932 3.932 0 0 0-.675.06 3.416 3.416 0 0 0-.605.168 3.052 3.052 0 0 0-.531.269 2.84 2.84 0 0 0-.64.562 2.758 2.758 0 0 0-.597 1.27 3.039 3.039 0 0 0-.041.896 3.115 3.115 0 0 0 .113.58 2.809 2.809 0 0 0 .544.99 2.734 2.734 0 0 0 .656.558 3 3 0 0 0 .542.263 3.353 3.353 0 0 0 .62.165 3.876 3.876 0 0 0 .687.058zm16.557-7.75a8.281 8.281 0 0 0 1.013-.063 7.1 7.1 0 0 0 .955-.194 6.259 6.259 0 0 0 .601-.2 5.832 5.832 0 0 0 .839-.413 5.457 5.457 0 0 0 1.421-1.228 5.803 5.803 0 0 0 .389-.53 6.266 6.266 0 0 0 .34-.593 6.912 6.912 0 0 0 .416-1.005 8.295 8.295 0 0 0 .212-.75 9.669 9.669 0 0 0 .153-.812 11.289 11.289 0 0 0 .118-1.338c.005-.157.009-.316.009-.479v-9.688h-5.616v9.04a11.593 11.593 0 0 1-.009.417c-.003.068-.008.135-.012.202a7.54 7.54 0 0 1-.018.197c-.007.065-.013.13-.021.193a5.36 5.36 0 0 1-.244 1.044 3.767 3.767 0 0 1-.196.444 2.998 2.998 0 0 1-.249.388 2.484 2.484 0 0 1-.416.42 2.217 2.217 0 0 1-.662.358 2.6 2.6 0 0 1-.478.117 3.15 3.15 0 0 1-.54.04 3.384 3.384 0 0 1-.552-.046 2.928 2.928 0 0 1-.83-.28 2.831 2.831 0 0 1-.303-.183 2.944 2.944 0 0 1-.515-.451 3.337 3.337 0 0 1-.398-.529 3.68 3.68 0 0 1-.334-.706 2.773 2.773 0 0 1-.097-.49 4.365 4.365 0 0 1-.03-.363 7.817 7.817 0 0 1-.007-.376v-9.436h-5.616l.01 2.418a3212.75 3212.75 0 0 1 .022 8.437v2.733a166.567 166.567 0 0 1-.02 2.858c-.004.2-.007.353-.011.452h5.616v-2.394c.035.054.07.109.108.165a8.966 8.966 0 0 0 .34.469 6.744 6.744 0 0 0 .414.48 5.67 5.67 0 0 0 .79.685 5.055 5.055 0 0 0 1.438.708 5.632 5.632 0 0 0 .671.167 6.298 6.298 0 0 0 .752.096 7.483 7.483 0 0 0 .548.02zm-19.402-.395h5.616V50.363h-5.616z",
    clipPath: "url(#a)",
    style: {
      fill: "#000102",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.5
    },
    transform: "matrix(.66298 0 0 -.66298 -170.998 54.157)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d6b58f1ac2ecc8aa7abc7b069f53af8b.svg";
export { ForwardRef as ReactComponent };